module.exports = __webpack_public_path__ + "media/images/area/feature/prefecture/gunma_excellence/005-9fcaaffc6a9e3d4598e948033fcf44fa.jpg";